import * as React from "react";
import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import { DesktopSidebar, SidebarContent } from "@/components/layout/Sidebar";
import { Header } from "@/components/layout/Header";
import { CommandPalette } from "@/components/layout/CommandPalette";
import { AICopilotPanel } from "@/components/layout/AICopilotPanel";
import { Drawer, DrawerContent } from "@/components/ui/drawer";
import { IdleSessionGuard } from "@/features/auth/IdleSessionGuard";
import { useCommandPalette } from "@/context/CommandPaletteContext";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { useKeyboardShortcut } from "@/hooks/useKeyboardShortcut";
import { useAlerts, useApprovals } from "@/api";
import { PageLoader } from "@/components/layout/PageLoader";

export function AppShell() {
  const [collapsed, setCollapsed] = useLocalStorage("eos-sidebar-collapsed", false);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { setOpen: setPaletteOpen } = useCommandPalette();

  const { data: alerts } = useAlerts();
  const { data: approvals } = useApprovals();

  useKeyboardShortcut({ key: "k", meta: true }, () => setPaletteOpen(true));

  const badgeCounts = {
    "Alerts Center": (alerts ?? []).filter((a) => a.status === "open").length || undefined,
    "Executive Inbox": (approvals ?? []).filter((a) => a.status === "pending").length || undefined,
  };

  return (
    <div className="flex min-h-screen bg-background">
      <DesktopSidebar collapsed={collapsed} onToggleCollapsed={() => setCollapsed((c) => !c)} badgeCounts={badgeCounts} />

      <Drawer open={mobileOpen} onOpenChange={setMobileOpen}>
        <DrawerContent side="left" widthClassName="w-72 max-w-[80vw]" hideClose className="bg-sidebar p-0">
          <SidebarContent onNavigate={() => setMobileOpen(false)} badgeCounts={badgeCounts} />
        </DrawerContent>
      </Drawer>

      <div className="flex min-w-0 flex-1 flex-col">
        <Header onOpenMobileSidebar={() => setMobileOpen(true)} />
        <main className="flex-1 px-4 py-6 sm:px-6 lg:px-8">
          <div className="mx-auto w-full max-w-[1600px]">
            <Suspense fallback={<PageLoader />}>
              <Outlet />
            </Suspense>
          </div>
        </main>
      </div>

      <CommandPalette />
      <AICopilotPanel />
      <IdleSessionGuard />
    </div>
  );
}
